module.exports = __webpack_public_path__ + "static/snippetscommand-3eb6fbbef0c72daf73aec19db35f11c9.png";